import { useEffect, useState } from "react";
import { getPage, getPageBYSlug } from "../api";
import { useRouteData } from "../RouteDataContext";
import { useParams } from "react-router-dom";
import { getProjectByProject } from "../projectData";
import { FullPageLoader } from "../../component/helper";

/**
 * PagePrivacy
 * Renders the privacy policy page using dashboard data.
 */
export const PagePrivacy = () => {
    const { dashboard } = useRouteData();
    let content = 'Not Added';
    if (dashboard?.pages?.length > 0) {
        content = dashboard?.pages[0]?.text;
    }

    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>

            <div className='card mt-4'>
                <div className='card-body p-3'>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
            </div>
        </div>
    )
}
/**
 * PageTerms
 * Renders the terms and conditions page using dashboard data.
 */
export const PageTerms = () => {
    const { dashboard } = useRouteData();
    let content = 'Not Added';
    if (dashboard?.pages?.length > 0) {
        content = dashboard?.pages[1]?.text;
    }
    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            <div className='card mt-4'>
                <div className='card-body p-3'>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
            </div>
        </div>
    )
}

/**
 * PageTermsCondition
 * Renders the terms and conditions page using project and URL params.
 */
export const PageTermsCondition = () => {
    const [pages, setPage] = useState([]);
    const { company, slug, UUID } = useParams()
    useEffect(() => {
        const project = getProjectByProject(company)
        if (project?.pkey || (slug && UUID)) {
            getPage({ project_key: project?.pkey, slug: slug, UUID: UUID }).then((d) => setPage(d?.data))
        }
    }, [company, slug, UUID])

    let content = 'Not Added';
    if (pages?.length > 0) {
        content = pages[1]?.text;
    }
    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            <div className='card'>
                <div className='card-body p-3'>
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
            </div>
        </div>
    )
}

/**
 * PageByUUID
 * Renders a page by UUID and slug, fetches content from API.
 */
export const PageByUUID = () => {
    const [content, setContent] = useState([]);
    const [loader, setLoader] = useState(true);

    const { slug, UUID } = useParams()
    useEffect(() => {
        if (slug && UUID) {
            getPageBYSlug({ slug: slug, UUID: UUID }).then((d) => setContent(d.data))
            setLoader(false);
        }
    }, [slug, UUID])



    return (
        <div className="container" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            {loader ? <FullPageLoader />
                : <div className='card'>

                    <div className='card-body p-3'>


                        <div dangerouslySetInnerHTML={{ __html: content?.text }}></div>

                    </div> </div>
            }

        </div>
    )
}